{
  "businessUnit": {
    "list": {
      "deviceCount": "{count} équipement|{count} équipement|{count} équipements"
    },
    "settings": {
      "description": {
        "information": "Informations",
        "title": "Informations"
      },
      "button": "Paramètres",
      "users": {
        "title": "Utilisateurs"
      },
      "firmwares": {
        "title": "Firmwares"
      },
      "logs": {
        "title": "Logs"
      }
    },
    "name": "Nom de la Business Unit",
    "addOrganization": {
      "button": "Créer une organisation"
    },
    "leave": {
      "title": "Mise à jour de la Business Unit"
    }
  },
  "entityLocation": {
    "location": "Localisation",
    "country": "Pays",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "timezone": "Fuseau horaire",
    "countryError": "Le pays est requis.",
    "latitudeError": "La latitude doit être comprise entre -90 et 90.",
    "longitudeError": "La longitude doit être comprise entre -180 et 180.",
    "timezoneError": "Le fuseau horaire est requis.",
    "countryPlaceholder": "Choisir le pays",
    "countrySearchPlaceholder": "Rechercher par nom de pays",
    "countryPopular": "Populaire"
  },
  "superAdministration": {
    "settings": {
      "title": "Modifier {name}",
      "information": {
        "title": "Informations",
        "subtitle": "Nom de l'organisation",
        "nameLabel": "Nom"
      },
      "button": "Paramètres",
      "users": {
        "title": "Utilisateurs"
      },
      "pki": {
        "title": "PKI",
        "newConnection": "Nouvelle connexion"
      },
      "logs": {
        "title": "Logs"
      }
    }
  },
  "organization": {
    "create": {
      "title": "Création d’une organisation",
      "saveButton": "Créer l'organisation"
    },
    "information": {
      "title": "Informations de l’organisation"
    },
    "name": "Nom de l’organisation",
    "type": {
      "label": "Type",
      "placeholder": "Choisir le type",
      "operator": "Organisation d'exploitation",
      "administration": "Organisation d'administration"
    },
    "nameRequiredError": "Le nom est requis.",
    "typeError": "Le type est requis.",
    "nameLengthError": "Longueur comprise entre {min} et {max} caractères.",
    "settings": {
      "information": {
        "title": "Informations"
      },
      "description": {
        "title": "Description"
      },
      "users": {
        "title": "Utilisateurs"
      },
      "operationButton": "Exploitation",
      "logs": {
        "title": "Logs"
      },
      "license": {
        "title": "Licence"
      },
      "certificate": {
        "title": "Certificat"
      }
    },
    "leave": {
      "title": "Mise à jour de l’organisation",
      "message": "Toutes les données non enregistrées seront perdues."
    }
  },
  "entityAdmin": {
    "lastname": "Nom de l’administrateur",
    "title": "Informations de l’administrateur",
    "firstname": "Prénom de l’administrateur",
    "login": "Login de l’administrateur",
    "email": "Email de l’administrateur",
    "language": "Langage"
  },
  "country": {
    "GRC": "Grèce",
    "MOZ": "Mozambique",
    "FRA": "France",
    "MUS": "Ile Maurice",
    "BWA": "Botswana",
    "CAF": "République centrafricaine",
    "FIN": "Finlande",
    "KAZ": "Kazakhstan",
    "MHL": "Îles Marshall",
    "MNE": "Monténégro",
    "MYS": "Malaisie",
    "NPL": "Népal",
    "NZL": "Nouvelle-Zélande",
    "PER": "Pérou",
    "USA": "Etats-Unis",
    "YEM": "Yémen",
    "CMR": "Cameroun",
    "CUB": "Cuba",
    "DOM": "République dominicaine",
    "ITA": "Italie",
    "LBR": "Liberia",
    "SWE": "Suède",
    "TUN": "Tunisie",
    "WSM": "Samoa",
    "CUW": "Curaçao",
    "DNK": "Danemark",
    "IDN": "Indonésie",
    "SGP": "Singapour",
    "SLV": "Salvador",
    "UGA": "Uganda",
    "URY": "Uruguay",
    "VEN": "Venezuela",
    "DEU": "Allemagne",
    "GUM": "Guam",
    "MKD": "Macédoine du Nord",
    "MWI": "Malawi",
    "PAK": "Pakistan",
    "PRT": "Portugal",
    "BEL": "Belgique",
    "BOL": "Bolivie",
    "COM": "Comores",
    "CHE": "Suisse",
    "GHA": "Ghana",
    "IRN": "Iran",
    "IRQ": "Irak",
    "JAM": "Jamaïque",
    "NLD": "Pays-Bas",
    "POL": "Pologne",
    "VAT": "Vatican",
    "AFG": "Afghanistan",
    "DZA": "Algérie",
    "HKG": "Hong Kong (Chine)",
    "LAO": "Laos",
    "NRU": "Nauru",
    "TKM": "Turkménistan",
    "ZMB": "Zambie",
    "AUS": "Australie",
    "BHS": "Bahamas",
    "BIH": "Bosnie-Herzégovine",
    "CZE": "République tchèque",
    "KOR": "Corée du Sud",
    "PHL": "Philippines",
    "VCT": "Saint-Vincent-et-les-Grenadines",
    "ARM": "Arménie",
    "AZE": "Azerbaïdjan",
    "BDI": "Burundi",
    "BGD": "Bangladesh",
    "ECU": "Equateur",
    "ETH": "Ethiopie",
    "GAB": "Gabon",
    "GMB": "Gambie",
    "HTI": "Haïti",
    "KIR": "Kiribati",
    "MAC": "Macao (Chine)",
    "MMR": "Birmanie",
    "PRI": "Porto Rico",
    "QAT": "Qatar",
    "SVK": "Slovaquie",
    "TGO": "Togo",
    "UKR": "Ukraine",
    "CAN": "Canada",
    "MLI": "Mali",
    "MNP": "Îles Mariannes du Nord",
    "SDN": "Soudan",
    "BRB": "Barbade",
    "FJI": "Fidji",
    "KGZ": "Kirghizistan",
    "MAF": "Saint-Martin (partie française)",
    "MRT": "Mauritanie",
    "ZWE": "Zimbabwe",
    "CA-QC": "Québec",
    "CHL": "Chili",
    "HRV": "Croatie",
    "SAU": "Arabie Saoudite",
    "ASM": "Samoa américaines",
    "BMU": "Bermudes",
    "COD": "Congo (Rép. dém.)",
    "CRI": "Costa Rica",
    "GIN": "Guinée",
    "IMN": "Île de Man",
    "JPN": "Japon",
    "SLB": "Îles Salomon",
    "SMR": "Saint-Marin",
    "SUR": "Suriname",
    "TCA": "Îles Turques-et-Caïques",
    "ATG": "Antigua-et-Barbuda",
    "COG": "Congo",
    "HND": "Honduras",
    "KNA": "Saint-Christophe-et-Niévès",
    "ROU": "Roumanie",
    "STP": "Sao Tomé-et-Principe",
    "ZAF": "Afrique du Sud",
    "BGR": "Bulgarie",
    "BRN": "Brunei",
    "CYP": "Chypre",
    "FSM": "Micronésie",
    "MAR": "Maroc",
    "MDA": "Moldavie",
    "MDG": "Madagascar",
    "MNG": "Mongolie",
    "SLE": "Sierra Leone",
    "TLS": "Timor oriental",
    "VNM": "Viêt Nam",
    "AGO": "Angola",
    "BLZ": "Belize",
    "HUN": "Hongrie",
    "IRL": "Irlande",
    "KWT": "Koweït",
    "MDV": "Maldives",
    "NER": "Niger",
    "NIC": "Nicaragua",
    "PSE": "Palestine",
    "TWN": "Taïwan",
    "ARG": "Argentine",
    "COL": "Colombie",
    "JOR": "Jordanie",
    "NAM": "Namibie",
    "SRB": "Serbie",
    "TJK": "Tadjikistan",
    "CPV": "Cap Vert",
    "GEO": "Géorgie",
    "KOS": "Kosovo",
    "LUX": "Luxembourg",
    "OMN": "Oman",
    "RUS": "Russie",
    "SOM": "Somalie",
    "SYC": "Seychelles",
    "TCD": "Tchad",
    "TUV": "Tuvalu",
    "AND": "Andorre",
    "BHR": "Bahreïn",
    "BRA": "Brésil",
    "DJI": "Djibouti",
    "DMA": "Dominique",
    "EST": "Estonie",
    "ISR": "Israël",
    "MCO": "Monaco",
    "MLT": "Malte",
    "SEN": "Sénégal",
    "SXM": "Saint Martin (partie néerlandaise)",
    "VUT": "Vanuatu",
    "ABW": "Aruba",
    "BEN": "Bénin",
    "BLR": "Biélorussie",
    "CYM": "Îles Caïmans",
    "GIB": "Gibraltar",
    "GNB": "Guinée-Bissau",
    "GRD": "Grenade",
    "IND": "Inde",
    "LBY": "Libye",
    "LCA": "Sainte-Lucie",
    "LVA": "Lettonie",
    "PRK": "Corée du Nord",
    "SSD": "Soudan du Sud",
    "TTO": "Trinité et Tobago",
    "ALB": "Albanie",
    "BTN": "Bhoutan",
    "CIV": "Côte d'Ivoire",
    "LKA": "Sri Lanka",
    "PAN": "Panama",
    "SYR": "Syrie",
    "UZB": "Ouzbékistan",
    "AUT": "Autriche",
    "EGY": "Egypte",
    "ERI": "Erythrée",
    "FRO": "Îles Féroé",
    "GNQ": "Guinée-Équatoriale",
    "GRL": "Groenland",
    "GUY": "Guyana",
    "LTU": "Lituanie",
    "MEX": "Mexique",
    "NOR": "Norvège",
    "RWA": "Rwanda",
    "SWZ": "Eswatini",
    "THA": "Thaïlande",
    "ARE": "Emirats arabes unis",
    "ESP": "Espagne",
    "GBR": "Royaume-Uni",
    "ISL": "Islande",
    "KEN": "Kenya",
    "LSO": "Lesotho",
    "NGA": "Nigéria",
    "PLW": "Palaos",
    "PNG": "Papouasie-Nouvelle-Guinée",
    "BFA": "Burkina Faso",
    "CHN": "Chine",
    "KHM": "Cambodge",
    "LBN": "Liban",
    "LIE": "Liechtenstein",
    "PRY": "Paraguay",
    "SVN": "Slovénie",
    "TON": "Tonga",
    "TUR": "Turquie",
    "TZA": "Tanzanie",
    "VGB": "Îles Vierges britanniques",
    "GTM": "Guatemala"
  },
  "relation": {
    "since": "Depuis : {date}",
    "delete": {
      "confirm": {
        "title": "Supprimer la relation",
        "description": "Voulez-vous vraiment supprimer la relation avec {name} ?"
      }
    }
  },
  "relations": {
    "affiliations": {
      "title": "Affiliation",
      "add": {
        "button": "Ajouter une affiliation"
      },
      "parentEntity": {
        "title": "Entité parente"
      },
      "childrenEntities": {
        "title": "Entités affiliées"
      }
    },
    "delegations": {
      "title": "Délégation",
      "add": {
        "button": "Ajouter une délégation"
      }
    },
    "title": "Relations",
    "add": {
      "createLink": "Créer un lien avec une organisation existante",
      "createOrganization": "Créer une nouvelle organisation"
    },
    "uploadIdCard": {
      "title": "Uploader l'ID card de l'organisation",
      "validation": {
        "fileMandatory": "Le fichier doit être un .JSON",
        "fileEmpty": "Le fichier ne doit pas être vide",
        "fileSize": "La taille du fichier doit être inférieure à 750Mo"
      }
    },
    "contact": {
      "administrator": "Administrateur :",
      "noContact": "Aucun contact identifié",
      "referentUser": {
        "title": "Contact de l’organisation",
        "description": "Contact désigné pour les demandes opérationnelles, de support ou commerciales liées à cette organisation.",
        "selectUser": "Sélectionner un utilisateur",
        "modified": "Changer le contact"
      }
    }
  }
}
